import React from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import { ConfigProvider } from "antd";
import Login from "./pages/Login";
import Wrapper from "./components/wrapper";
import Dashboard from "./pages/Dashboard/index";
import AccessDenied from "./pages/AccessDenied";
import PrivateRoute from "./PrivateRoute";
import "./assets/styles/globals.css";

import dayjs from "dayjs";
import "dayjs/locale/fa"; // import the fa locale
import jalali from 'dayjs-jalali'
dayjs.extend(jalali);
dayjs.locale("fa"); // set the locale to fa


const App = () => {

  return (
    <ConfigProvider direction="rtl">
        <Wrapper>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/access-denied" element={<AccessDenied />} />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              ></Route>
            </Routes>
          </BrowserRouter>
        </Wrapper>
    </ConfigProvider>
  );
};

export default App;
